import React from 'react';
import BrandIcon from '../../../BrandIcon';
import Icon from '../../../Icon';
import MultiColorIcon from '../../../MultiColorIcon';
import { AVATAR_ICON_SIZES } from '../../constants';
const AvatarIcon = ({ icon, iconType, size }) => {
    const iconSize = size && AVATAR_ICON_SIZES[size];
    switch (iconType) {
        case 'brand':
            return React.createElement(BrandIcon, { name: icon, size: iconSize });
        case 'icon':
            return React.createElement(Icon, { name: icon, size: iconSize });
        case 'multiColor':
            return React.createElement(MultiColorIcon, { name: icon, size: iconSize });
        default:
            return null;
    }
};
export default AvatarIcon;
